import { render, staticRenderFns } from "./ClustersView.vue?vue&type=template&id=4a78132a&"
import script from "./ClustersView.vue?vue&type=script&lang=js&"
export * from "./ClustersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports